import useTranslation from "next-translate/useTranslation";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  actions as ListingreducerActions,
  selectors as ListingreducerSelectors,
} from "redux/slices/v2/ListingReducer";
import BienTypeSelect from "../BienTypeSelect";
import InputSelect from "../PriceRangeSelect/InputSelect";
import TypologieSelectView from "../TypologieSelectView";
import styles from "./FiltersDialog.module.scss";
import $ from "utils/selectors";
import CheckMark from "ui/CheckMark/CheckMark";

const MIN_PRICES_LIST_VENTE = [
  0, 250000, 500000, 750000, 1000000, 1500000, 2000000, 3000000, 5000000,
];

const MAX_PRICES_LIST_VENTE = [
  1000000, 2500000, 5000000, 7500000, 10000000, 15000000, 20000000, 30000000,
  50000000,
];

const MIN_PRICES_LIST_LOCATION = [
  0, 1000, 2500, 3500, 4500, 5500, 7000, 8000, 10000, 12000,
];

const MAX_PRICES_LIST_LOCATION = [
  6000, 7000, 8000, 9000, 10000, 12000, 15000, 17000, 18500, 20000,
];

export default function FiltersDialog({
  transactionType,
  onResetFilters,
  onValidateFilters,
  totalListingsCount,
  onSurfaceRangeChange,
  onPriceRangeChange,
  button = false,
  // className,
}: {
  transactionType: "Vente" | "Location" | "Projets Neufs" | "";
  onResetFilters: () => void;
  onValidateFilters: (filters: {
    types: string[];
    caracteristics: string[];
    typologies: number[];
    minSurface: number | undefined;
    maxSurface: number | undefined;
    meublee: boolean;
  }) => void;
  totalListingsCount?: any;
  onSurfaceRangeChange: ({
    minSurface,
    maxSurface,
  }: {
    minSurface?: any;
    maxSurface?: any;
  }) => void;
  onPriceRangeChange: ({
    minPrice,
    maxPrice,
  }: {
    minPrice?: number;
    maxPrice?: number;
  }) => void;
  button: Boolean;
  // className: any;
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation("commonAnnonces");
  const searchPayload = useSelector(
    ListingreducerSelectors.searchPayloadSelector
  );
  const mapVsList = useSelector(ListingreducerSelectors.mapVsListSelactor);

  const [displayFiltersDialog, setDisplayFiltersDialog] =
    useState<boolean>(false);
  const [types, setTypes] = useState<string[]>([]);
  const [caracteristics, setCaracteristics] = useState<string[]>(
    searchPayload ? searchPayload.caracteristiques : []
  );
  const [typologies, setTypologie] = useState<number[]>(
    searchPayload.typologie ? searchPayload.typologie : []
  );

  const [maxSurface, setMaxSurface] = useState<number | string | undefined>(
    undefined
  );
  const [minSurface, setMinSurface] = useState<number | string | undefined>(
    undefined
  );
  const [meublee, setMeublee] = useState(false);
  useEffect(() => {
    window.addEventListener("resize", () => {
      $("#scrollfilter--container").attr(
        "style",
        `height : calc(${window.innerHeight}px - 160px) !important`
      );
    });
    $("#scrollfilter--container").attr(
      "style",
      `height : calc(${window.innerHeight}px - 160px) !important`
    );
  }, []);
  useEffect(() => {
    if (window.innerWidth < 990) {
      if (displayFiltersDialog) {
        $("#search_form_annonce").attr("style", `z-index : 0`);
        $("body").css("height", "100%");
        $("body").css("overflow", "hidden");
      } else {
        $("#search_form_annonce").attr("style", `z-index : 10`);
        if (!mapVsList) {
          $("body").css("height", "auto");
          $("body").css("overflow", "scroll");
        }
      }
    }
  }, [displayFiltersDialog]);
  const countFilters = (searchPayload) => {
    let count = 0;

    if (searchPayload) {
      if (searchPayload.typologie.length > 0) {
        count = count + 1;
      }
      if (searchPayload.type.length > 0) {
        count = count + 1;
      }
      if (searchPayload.caracteristiques.length > 0) {
        count = count + 1;
      }
      if (searchPayload.surfacemax || searchPayload.surfacemin) {
        count = count + 1;
      }
      if (searchPayload.prixmax || searchPayload.prixmin) {
        count = count + 1;
      }
      if (searchPayload.meublee) {
        count = count + 1;
      }
    }
    return count;
  };
  const [filtersCount, setFiltersCount] = useState<number>(
    countFilters(searchPayload)
  );

  useEffect(() => {
    if (searchPayload) {
      let count = countFilters(searchPayload);

      setFiltersCount(count);
    }
  }, [searchPayload]);
  const validateFilters = () => {
    // onValidateFilters({
    //   types,
    //   caracteristics,
    //   typologies,
    //   minSurface,
    //   maxSurface,
    //   meublee,
    // });
    $("#search-bar-input").css("z-index", "1");
    $("#search-bar-input2").css("z-index", "1");
    dispatch(ListingreducerActions.setDisplayMobileSearchBar(true));
    setDisplayFiltersDialog(false);
  };

  const resetFilters = () => {
    onResetFilters();
    $("#search-bar-input").css("z-index", "1");
    $("#search-bar-input2").css("z-index", "1");
    dispatch(ListingreducerActions.setDisplayMobileSearchBar(true));
    setDisplayFiltersDialog(false);
    setMaxValue("");
    setMinValue("");
    onSurfaceRangeChange({
      minSurface: parseInt(""),
      maxSurface: parseInt(""),
    });
  };

  const typologieChangeHandler = (selectedTypologie: number) => {
    let updatedTypologie = [...typologies];
    if (!typologies.includes(selectedTypologie))
      updatedTypologie.push(selectedTypologie);
    else {
      updatedTypologie = typologies.filter(
        (item) => item !== selectedTypologie
      );
    }
    setTypologie(updatedTypologie);
  };

  useEffect(() => {
    if (searchPayload) {
      setTypologie(searchPayload.typologie);
    }
  }, [searchPayload]);
  const listingsSearchPayload = useSelector(
    ListingreducerSelectors.searchPayloadSelector
  );

  const [caracteristiques, setCaracteristiques] = useState(
    listingsSearchPayload.caracteristiques
  );

  const [minValue, setMinValue] = useState(
    listingsSearchPayload.prixmin
      ? listingsSearchPayload.prixmin.toString()
      : ""
  );
  const [maxValue, setMaxValue] = useState(
    listingsSearchPayload.prixmax
      ? listingsSearchPayload.prixmax.toString()
      : ""
  );
  const [minValuePrice, setMinValuePrice] = useState(
    listingsSearchPayload.prixmin
      ? listingsSearchPayload.prixmin.toString()
      : ""
  );
  const [maxValuePrice, setMaxValuePrice] = useState(
    listingsSearchPayload.prixmax
      ? listingsSearchPayload.prixmax.toString()
      : ""
  );
  const [checkedVirtual3D, setCheckedVirtual3D] = useState(
    searchPayload?.virtual_tour ? searchPayload?.virtual_tour : false
  );
  const [checkedExclu, setCheckedExclu] = useState(
    searchPayload?.exclusivite ? searchPayload?.exclusivite : false
  );

  useEffect(() => {
    setCheckedVirtual3D(
      searchPayload?.virtual_tour ? searchPayload?.virtual_tour : false
    )
    setCheckedExclu(
      searchPayload?.exclusivite ? searchPayload?.exclusivite : false
    )
  }, [searchPayload])

  const [anciennete, setAnciennete] = useState(
    listingsSearchPayload.anciennete
  );
  const [etat, setEtat] = useState(listingsSearchPayload.etat);
  const [sallesDeBain, setSallesDeBain] = useState(
    listingsSearchPayload.sallesDeBain
  );

  const dispatchtheCaracteristiques = () => {
    dispatch(
      ListingreducerActions.setSearchPayload({
        searchPayload: {
          type: types,
          etat: etat,
          anciennete: anciennete,
          sallesDeBain: sallesDeBain,
          caracteristiques: caracteristiques,
          lat: listingsSearchPayload.lat ? listingsSearchPayload.lat : null,
          lng: listingsSearchPayload.lng ? listingsSearchPayload.lng : null,
          typologie: typologies,
          page: 0,
          prixmax:
            typeof maxValuePrice == "string"
              ? parseInt(maxValuePrice.replace(/ /g, ""))
              : maxValuePrice,
          prixmin:
            typeof minValuePrice == "string"
              ? parseInt(minValuePrice.replace(/ /g, ""))
              : minValuePrice,
          surfacemax:
            typeof maxSurface == "string"
              ? parseInt(maxSurface.replace(/ /g, ""))
              : maxSurface,
          surfacemin:
            typeof minSurface == "string"
              ? parseInt(minSurface.replace(/ /g, ""))
              : minSurface,
          exclusivite: checkedExclu,
          virtual_tour: checkedVirtual3D,
        },
      })
    );
  };
  useEffect(() => { }, [maxValuePrice]);
  useEffect(() => { }, [maxValue]);

  const arraySdb = [-1, 1, 2, 3, 4];
  return (
    <>
      <div
        className={
          button
            ? ""
            : `${styles.filtersBtnContainer} ${filtersCount ? styles.filtersBtnActive : ""
            }`
        }
      >
        {button ? (
          <>
            <button
              className={styles.filterBtnS}
              onClick={() => {
                $("#search-bar-input").css("z-index", "-1");
                $("#search-bar-input2").css("z-index", "-1");
                dispatch(
                  ListingreducerActions.setDisplayMobileSearchBar(false)
                );
                setDisplayFiltersDialog(true);
              }}
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M5.00016 9.99999L3.3335 9.99999M5.00016 9.99999C5.00016 10.9205 5.74635 11.6667 6.66683 11.6667C7.5873 11.6667 8.3335 10.9205 8.3335 9.99999M5.00016 9.99999C5.00016 9.07952 5.74635 8.33332 6.66683 8.33332C7.5873 8.33332 8.3335 9.07952 8.3335 9.99999M15.0002 15C15.0002 14.0795 14.254 13.3333 13.3335 13.3333C12.413 13.3333 11.6668 14.0795 11.6668 15M15.0002 15C15.0002 15.9205 14.254 16.6667 13.3335 16.6667C12.413 16.6667 11.6668 15.9205 11.6668 15M15.0002 15L16.6668 15M11.6668 15L3.3335 15M8.3335 9.99999L16.6668 9.99999M15.0002 4.99999C15.0002 4.07952 14.254 3.33332 13.3335 3.33332C12.413 3.33332 11.6668 4.07952 11.6668 4.99999M15.0002 4.99999C15.0002 5.92047 14.254 6.66666 13.3335 6.66666C12.413 6.66666 11.6668 5.92047 11.6668 4.99999M15.0002 4.99999L16.6668 4.99999M11.6668 4.99999L3.3335 4.99999"
                    stroke="#00111A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </button>
            <button
              className={styles.filterBtnM}
              onClick={() => {
                $("#search-bar-input").css("z-index", "-1");
                $("#search-bar-input2").css("z-index", "-1");
                dispatch(
                  ListingreducerActions.setDisplayMobileSearchBar(false)
                );
                setDisplayFiltersDialog(true);
              }}
            >
              <span style={{ color: "black" }}>
                {t("Filtres")}
                {filtersCount ? `(${filtersCount})` : ""}
              </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="7"
                viewBox="0 0 14 8"
                fill="none"
              >
                <path
                  d="M13 1L7 7L1 1"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </>
        ) : (
          <button
            className={styles.filterBtn}
            onClick={() => {
              $("#search-bar-input").css("z-index", "-1");
              $("#search-bar-input2").css("z-index", "-1");
              dispatch(ListingreducerActions.setDisplayMobileSearchBar(false));
              setDisplayFiltersDialog(true);
            }}
          >
            <span style={{ color: "black" }}>
              {t("Filtres")}
              {filtersCount ? `(${filtersCount})` : ""}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="7"
              viewBox="0 0 14 8"
              fill="none"
            >
              <path
                d="M13 1L7 7L1 1"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
      </div>

      <div
        className={`${displayFiltersDialog ? styles.filtersScreen : styles.displayNone
          }`}
      >
        <div className={styles.close_and_result}>
          <p className={styles.result_paragraph}>
            {totalListingsCount} {t("résultats")}
          </p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            className={styles.close_svg}
            onClick={() => {
              dispatch(ListingreducerActions.setDisplayMobileSearchBar(true));
              setDisplayFiltersDialog(false);
            }}
          >
            <path
              d="M8.46954 6.94546L13.7595 1.65046C13.9234 1.45916 14.009 1.21308 13.9993 0.961404C13.9895 0.709728 13.8852 0.470988 13.7071 0.292894C13.529 0.114799 13.2903 0.0104669 13.0386 0.000745782C12.7869 -0.00897537 12.5408 0.0766307 12.3495 0.240457L7.05454 5.53046L1.75954 0.240457C1.56824 0.0766307 1.32217 -0.00897537 1.07049 0.000745782C0.818814 0.0104669 0.580075 0.114799 0.40198 0.292894C0.223886 0.470988 0.119553 0.709728 0.109832 0.961404C0.100111 1.21308 0.185717 1.45916 0.349544 1.65046L5.63954 6.94546L0.349544 12.2405C0.244862 12.3301 0.159841 12.4404 0.0998179 12.5645C0.0397946 12.6886 0.00606468 12.8237 0.000745182 12.9614C-0.00457431 13.0991 0.0186315 13.2365 0.0689061 13.3648C0.119181 13.4931 0.195439 13.6097 0.292893 13.7071C0.390348 13.8046 0.506896 13.8808 0.635221 13.9311C0.763546 13.9814 0.900878 14.0046 1.0386 13.9993C1.17632 13.9939 1.31145 13.9602 1.43551 13.9002C1.55958 13.8402 1.6699 13.7551 1.75954 13.6505L7.05454 8.36046L12.3495 13.6505C12.5408 13.8143 12.7869 13.8999 13.0386 13.8902C13.2903 13.8804 13.529 13.7761 13.7071 13.598C13.8852 13.4199 13.9895 13.1812 13.9993 12.9295C14.009 12.6778 13.9234 12.4318 13.7595 12.2405L8.46954 6.94546Z"
              fill="black"
            />
          </svg>
        </div>
        <div className={styles.new_filters_container}>
          <div className={styles.new_filters_section_transactionType}>
            <span
              className={`${searchPayload.transaction_type === "Vente"
                ? styles.span_active
                : ""
                }`}
              onClick={() => {
                dispatch(
                  ListingreducerActions.setSearchPayload({
                    searchPayload: {
                      ...searchPayload,
                      transaction_type: "Vente",
                      page: 0,
                      exclusivite: false,
                      virtual_tour: false,
                    },
                  })
                );
              }}
            >
              {t("À vendre")}
            </span>
            <span
              className={`${searchPayload.transaction_type === "Location"
                ? styles.span_active
                : ""
                }`}
              onClick={() => {
                dispatch(
                  ListingreducerActions.setSearchPayload({
                    searchPayload: {
                      ...searchPayload,
                      transaction_type: "Location",
                      page: 0,
                      exclusivite: false,
                      virtual_tour: false,
                    },
                  })
                );
              }}
            >
              {t("À louer")}
            </span>
            <span
              className={`${searchPayload.transaction_type === "Projets Neufs"
                ? styles.span_active
                : ""
                }`}
              onClick={() => {
                dispatch(
                  ListingreducerActions.setSearchPayload({
                    searchPayload: {
                      ...searchPayload,
                      transaction_type: "Projets Neufs",
                      page: 0,
                      exclusivite: false,
                      virtual_tour: false,
                    },
                  })
                );
              }}
            >
              {t("Projets Neufs")}
            </span>
          </div>
          {searchPayload.vendu ? (null):(
            <div className={styles.new_filters_section}>
              <span className={styles.filters_section_title}>{t("Prix")}</span>
              <div className={styles.max_min_container}>
                <div className={styles.maximum_prix}>
                  <span className={styles.prix_text}>{t("Minimum")}</span>
                  <div style={{ width: "100%", height: "44px" }}>
                    <InputSelect
                      array={
                        searchPayload.transaction_type == "Location"
                          ? MIN_PRICES_LIST_LOCATION
                          : MIN_PRICES_LIST_VENTE
                      }
                      defaultValue={minValuePrice}
                      setDefaultValue={setMinValuePrice}
                      placeHolder={t("0 MAD")}
                      maxValue={9999999999999}
                      name="minValueInput"
                      symbol={t("MAD")}
                    />
                  </div>
                </div>
                <div className={styles.separator_container}>
                  <span className={styles.separator}>-</span>
                </div>
                <div className={styles.maximum_prix}>
                  <span className={styles.prix_text}>{t("Maximum")}</span>
                  <div style={{ width: "100%", height: "44px" }}>
                    <InputSelect
                      array={
                        searchPayload.transaction_type == "Location"
                          ? MAX_PRICES_LIST_LOCATION
                          : MAX_PRICES_LIST_VENTE
                      }
                      defaultValue={maxValuePrice}
                      setDefaultValue={setMaxValuePrice}
                      placeHolder={t("Aucun")}
                      maxValue={500000000000000}
                      name="maxValueInput"
                      symbol={t("MAD")}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className={styles.new_filters_section}>
            <span className={styles.filters_section_title}>{t("Type")}</span>
            <BienTypeSelect
              styleForFilters={true}
              hideTitle={true}
              transactionType={transactionType}
              onTypesSelected={() => { }}
              variant="VIEW"
              onTypesSelectionChange={(types) => {
                setTypes(types);
              }}
            />
          </div>
          <div className={styles.new_filters_section}>
            <span className={styles.filters_section_title}>
              {t("Chambres")}
            </span>
            <TypologieSelectView
              hideTitle={true}
              onTypologieChange={(typologie: number) =>
                typologieChangeHandler(typologie)
              }
              typologies={typologies}
            />
          </div>
          {/* <div className={styles.new_filters_section}>
            <span className={styles.filters_section_title}>{t("Salles de bains")}</span>
            <div className={styles.sdb_section}>
            {arraySdb.map((i, id) => {
              return (
                <button
                  className={(i === sallesDeBain || sallesDeBain === -1) ? styles.sdb_section_button_blue : styles.sdb_section_button}
                  key={id}
                  onClick={() => {
                    if (sallesDeBain === -1 && i === -1)
                      setSallesDeBain(0)
                    else
                      setSallesDeBain(i)
                  }}
                >
                    <span className={styles.sdb_section_button_paragraph}>{i === -1 ? t("Tout") : i}{i === 4 ? "+" : ""}</span>
                </button>
              )
            })}
            </div>

          </div> */}
          <div className={styles.exclu3dtourCon}>
            <div className={styles.new_filters_section_v2}>
              <p className={styles.filters_section_title}>{t("Visite 3D")}</p>
              <div
                className={styles.checkbox}
                onClick={() => {
                  setCheckedVirtual3D(!checkedVirtual3D);
                }}
              >
                <CheckMark checked={checkedVirtual3D} isBlue={true} />
                <p className={styles.checkedText}>
                  {t("Annonces avec visite 3D")}
                </p>
              </div>
            </div>
            <div className={styles.new_filters_section_v2}>
              <p className={styles.filters_section_title}>
                {t("Exclusivités agenz")}
              </p>
              <div
                className={styles.checkbox}
                onClick={() => {
                  setCheckedExclu(!checkedExclu);
                }}
              >
                <CheckMark checked={checkedExclu} isBlue={true} />
                <p className={styles.checkedText}>
                  {t("Annonces exclusives agenz")}
                </p>
              </div>
            </div>
          </div>

          <div className={styles.new_filters_section}>
            <p className={styles.filters_section_title}> {t("Surface")}</p>
            <div className={styles.max_min_container}>
              <div className={styles.maximum_prix}>
                <span className={styles.prix_text}>{t("Minimum")}</span>
                <div style={{ width: "100%", height: "44px" }}>
                  <InputSelect
                    array={[0, 25, 50, 75, 100, 150, 200, 300, 500]}
                    defaultValue={minSurface}
                    setDefaultValue={setMinSurface}
                    placeHolder={t("0 m²")}
                    maxValue={9999999999999}
                    name="minValueInputSurface"
                    symbol={t("m²")}
                  />
                </div>
              </div>
              <div className={styles.separator_container}>
                <span className={styles.separator}>-</span>
              </div>
              <div className={styles.maximum_prix}>
                <span className={styles.prix_text}>{t("Maximum")}</span>
                <div style={{ width: "100%", height: "44px" }}>
                  <InputSelect
                    array={[50, 75, 100, 150, 200, 300, 400, 500, 750, 1000]}
                    defaultValue={maxSurface}
                    setDefaultValue={setMaxSurface}
                    placeHolder={t("Aucun")}
                    maxValue={9999999999999}
                    name="maxValueInputSurface"
                    symbol={t("m²")}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* <div className={styles.new_filters_section}>
            <p className={styles.filters_section_title}>
              {" "}
              {t("Ancienneté de la construction")}
            </p>
            <CustomSelectDropdown
              title={""}
              displayTitle={false}
              choices={[
                t("Neuve"),
                t("Entre 1 et 5 ans"),
                t("Entre 6 et 10 ans"),
                t("Entre 11 et 20 ans"),
                t("Plus de 20 ans"),
                t("Je ne sais pas"),
              ]}
              displayCustomPlaceholder={true}
              customPlaceholder={t("-- Choisir --")}
              valueRequired={anciennete}
              setValueRequired={(value) => {
                setAnciennete(value);
              }}
            />
          </div>
          <div className={styles.new_filters_section}>
            <p className={styles.filters_section_title}> {t("État du bien")}</p>
            <CustomSelectDropdown
              title={""}
              displayTitle={false}
              choices={[
                t("Neuf"),
                t("Correct"),
                t("Refait à neuf"),
                t("Travaux à prévoir"),
              ]}
              displayCustomPlaceholder={true}
              customPlaceholder={t("-- Choisir --")}
              valueRequired={etat}
              setValueRequired={(value) => {
                setEtat(value);
              }}
            />
          </div>
          <span className={styles.prix_text} style={{ color: "#460AF0" }}>
            {t("Surface extérieure")}
          </span> */}
          {/* <div className={styles.caraccteristique_filters}>
            <span className={styles.prix_text} >{t("A un balcon ")}</span>
            <FilterCheckBox name="Balcon" caracteristiques={caracteristiques} setCaracteristiques={setCaracteristiques}/>
            <span className={styles.prix_text} >{t("A une terrasse")}</span>
            <FilterCheckBox name="Terrasse" caracteristiques={caracteristiques} setCaracteristiques={setCaracteristiques}/>
            <span className={styles.prix_text} >{t("A un parking")}</span>
            <FilterCheckBox name="Parking" caracteristiques={caracteristiques} setCaracteristiques={setCaracteristiques}/>
            <span className={styles.prix_text} >{t("A un ascenseur")}</span>
            <FilterCheckBox name="Ascenseur" caracteristiques={caracteristiques} setCaracteristiques={setCaracteristiques}/>
            <span className={styles.prix_text} style={{marginBottom: "10px"}}>{t("Autre caractéristiques")}</span>
            <FilterCheckBox name="Chambre de service" caracteristiques={caracteristiques} setCaracteristiques={setCaracteristiques}/>
            <FilterCheckBox name="Sans vis-à-vis" caracteristiques={caracteristiques} setCaracteristiques={setCaracteristiques}/>
            <FilterCheckBox name="Résidence férmée" caracteristiques={caracteristiques} setCaracteristiques={setCaracteristiques}/>
            <FilterCheckBox name="Meublé" caracteristiques={caracteristiques} setCaracteristiques={setCaracteristiques}/>
          </div> */}
        </div>
        <div className={styles.valider__container_new}>
          <button
            onClick={() => {
              dispatchtheCaracteristiques();
              validateFilters();
            }}
            className={styles.button_valider_new}
          >
            {t("Valider")}
          </button>
        </div>
      </div>
    </>
  );
}
